import { Box, Text } from '@wix/design-system';
import React from 'react';
import { useIsStudioNewUi } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
import s from '../Checkout.scss';
import { CheckoutDisclaimerLink } from './CheckoutDisclaimerLink';
const URLS = {
  TERMS_OF_USE: 'https://www.wix.com/about/terms-of-use',
  PRIVACY_POLICY: 'https://www.wix.com/about/privacy'
};
export const CheckoutDisclaimer = () => {
  const currentModule = useCurrentModule();
  const {
    Trans
  } = currentModule.internals.useTranslations();
  const isStudioNewUi = useIsStudioNewUi();
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    weight: "thin",
    size: "tiny",
    secondary: true,
    className: isStudioNewUi ? s.newUiDisclaimer : undefined
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "checkout.disclaimer_terms_of_service",
    components: [/*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(CheckoutDisclaimerLink, {
      url: URLS.TERMS_OF_USE
    }), /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(CheckoutDisclaimerLink, {
      url: URLS.PRIVACY_POLICY
    })]
  })));
};
//# sourceMappingURL=CheckoutDisclaimer.js.map